import { Cirus } from "@/classes/Http";

class Body {
    email: string
}

export function sendEmailVerificationCode(body: Body) {
    const query = '/user/send-email-verification';
    return Cirus.post(query, body, null, null, process.env.VUE_APP_authURL);
}
